<template>
  <div class="layout-cart-products">
    <div class="products">
      <div class="products-items">
        <div v-for="(product, index) in products" :key="index" class="product">
          <div class="image">
            <img :src="product.pic" alt="" />
          </div>
          <div class="name">
            <div class="subtitle">{{ product.name }}</div>
            <ui-product-counter v-model="product.count"></ui-product-counter>
          </div>
          <div class="params">
            <div class="price">${{ product.price.toLocaleString() }}</div>
            <div class="delete"><img src="@/assets/icons/delete.svg" alt="" /></div>
          </div>
        </div>
      </div>
    </div>
    <div class="results">
      <div class="xs-title">detail info</div>
      <div class="table">
        <div class="table-row">
          <div class="table-cell">
            Subtotal
          </div>
          <div class="table-cell"></div>
          <div class="table-cell">${{ subtotal.toLocaleString() }}</div>
        </div>
        <div class="table-row">
          <div class="table-cell">
            Shipping
          </div>
          <div class="table-cell"></div>
          <div class="table-cell">${{ cart.shipping.toLocaleString() }}</div>
        </div>
        <div class="table-row">
          <div class="table-cell">
            Promocode
          </div>
          <div class="table-cell">
            <div class="input">
              <input type="text" placeholder="Promocode" />
              <div class="apply">
                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.5606 0.606689L4.65281 6.51446L1.43941 3.30109L0 4.7405L4.65281 9.39331L12 2.04613L10.5606 0.606689Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="table-cell"></div>
        </div>
        <div class="table-row">
          <div class="table-cell">
            Total
          </div>
          <div class="table-cell"></div>
          <div class="table-cell">${{ total.toLocaleString() }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uiProductCounter from '@/components/ui/ui-product-counter'
// import vuescroll from 'vuescroll/dist/vuescroll-native'
export default {
  components: {
    // vuescroll,
    uiProductCounter
  },
  props: {
    products: {
      type: Array,
      default() {
        return []
      }
    },
    cart: {
      type: Object,
      default() {
        return {}
      }
    },
    subtotal: {
      type: Number,
      default() {
        return 0
      }
    },
    total: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          background: '#000',
          opacity: 0.1,
          size: '3px',
          specifyBorderRadius: '0px'
        },
        bar: {
          background: '#000',
          opacity: 1,
          size: '3px'
        }
      }
    }
  },
  methods: {
    getSizes(product) {
      return product.sizes.split(',')
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-cart-products {
  display: flex;
  flex-direction: column;
  & > *:nth-child(1) {
    flex-grow: 1;
  }
}
.products {
  position: relative;
  margin-bottom: 2em;
}
.input {
  position: relative;
  .apply {
    width: 1.5em;
    height: 1.5em;
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color);
    cursor: pointer;
  }
}
.product {
  display: flex;
  &:not(:last-child) {
    border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  }
  padding: 1em 0;
  .image {
    width: 5em;
    height: 5em;
    margin-right: 2em;
  }
  .name {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
    width: 40%;
    .subtitle {
      margin-bottom: 0.5em;
    }
  }
  .size {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
    .subtitle {
      margin-bottom: 0.5em;
    }
    select {
      height: 2.3em;
      border-color: rgba(0, 0, 0, 0.1);
    }
  }
  .params {
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
  }
}
.table {
  display: table;
  width: 100%;
  margin-top: 1em;
  .table-row {
    display: table-row;
    .table-cell {
      font-size: 0.875em;
      display: table-cell;
      padding: 0.2em 0;
      &:nth-child(1) {
        width: 50%;
      }
      &:nth-child(3) {
        text-align: right;
        width: 20%;
      }
    }
    &:last-child {
      .table-cell {
        font-weight: 700;
        padding-top: 2em;
      }
    }
  }
}
input {
  border: none;
  border-bottom: solid 1px currentColor;
  padding: 0.4em 0;
  height: auto;
  text-transform: uppercase;
  &::-webkit-input-placeholder {
    color: rgba(0, 0, 0, 1);
  }
  &::-moz-placeholder {
    color: rgba(0, 0, 0, 1);
  }
  &:-moz-placeholder {
    color: rgba(0, 0, 0, 1);
  }
  &:-ms-input-placeholder {
    color: rgba(0, 0, 0, 1);
  }
}
@media screen and (max-width: 767px) {
  .products {
    .abs {
      position: relative;
      height: auto;
      width: auto;
    }
  }
}
</style>
